/** Тексты окна: С возвращением: офлайн-доход и серия. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.welcome.title": "Welcome back!",
  "win.welcome.away": "While you were away",
  "win.welcome.held": "Your base held for {time}",
  "win.welcome.storage": "Storage",
  "win.welcome.storageFullIn": "Full in {time} · max {max}",
  "win.welcome.storageFull": "Storage is full · max {max} — upgrade it in Tech",
  "win.welcome.claimAll": "Claim all",
  "win.time.hm": "{h}h {m}m",
  "win.time.h": "{h}h",
  "win.time.m": "{m}m",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.welcome.title": "С возвращением!",
  "win.welcome.away": "Пока тебя не было",
  "win.welcome.held": "Штаб держался {time}",
  "win.welcome.storage": "Склад",
  "win.welcome.storageFullIn": "Заполнится через {time} · максимум {max}",
  "win.welcome.storageFull": "Склад полон · максимум {max} — расширь его в Tech",
  "win.welcome.claimAll": "Забрать всё",
  "win.time.hm": "{h} ч {m} мин",
  "win.time.h": "{h} ч",
  "win.time.m": "{m} мин",
};

const uk: Record<Key, string> = {
  "win.welcome.title": "З поверненням!",
  "win.welcome.away": "Поки тебе не було",
  "win.welcome.held": "Штаб тримався {time}",
  "win.welcome.storage": "Склад",
  "win.welcome.storageFullIn": "Заповниться через {time} · максимум {max}",
  "win.welcome.storageFull": "Склад повний · максимум {max}, розшир його в Штабі",
  "win.welcome.claimAll": "Забрати все",
  "win.time.hm": "{h} год {m} хв",
  "win.time.h": "{h} год",
  "win.time.m": "{m} хв",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
